import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Upload, Spin } from 'antd'
import MyIcon from '../../../components/general/icon'
import { apiBaseURL } from '../../../request'

const ImportAlmamaterVisit = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [isLoading, setIsLoading] = useState(false)

  const imageUpload = {
    name: 'doc',
    action: `${apiBaseURL}/common/doc/upload`,
    headers: {
      authorization: localStorage.getItem('token'),
    },
    onChange(info) {
      if (info.file.status === 'done') {
        handleImportInfo(info.file.response.data.doc_url)
      }
    },
  }

  const handleImportInfo = (filename) => {
    setIsLoading(true)
    axios.post('/p/almamater_visit/data/import', { 
      merchant_oid: merchantOid, 
      category_oid: props.filterValue.category,
      filename: filename
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('数据导入成功！')
          setIsLoading(false)
          props.isCancel()
          props.getMemberData()
        } else {
          message.error(response.msg)
          setIsLoading(false)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleDownload = () => {
    setIsLoading(true)
    axios.post('/common/excel_template/download', { 
      name: 'mxx'
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('导入模版下载成功！')
          setIsLoading(false)
          const link = document.createElement('a')
          link.href = response.data.download_address
          link.setAttribute('download', '')
          link.click()
          document.body.removeChild(link)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <>
      <Modal
        width={400}
        title="母校行数据导入"
        open={props.isOpen}
        onCancel={props.isCancel}
        maskClosable={false}
        footer=''
      >

        <Spin spinning={isLoading}>
          <div className='public-import-container'>
            <div className='public-import-box'>
              <div className='public-import-icon'><MyIcon name='daoru' /></div>
              <div className='public-import-title'>导入母校行数据</div>
              <div className='public-import-despcription'>导入数据前请先下载导入模版，根据模版格式导入</div>

              <Upload {...imageUpload} showUploadList={false}>
                <div className='public-import-button1'>
                  <p>导入信息</p>
                </div>
              </Upload>

              <div className='public-import-button2' onClick={() => { handleDownload() }}>
                <p>下载模版</p>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  )
}

export default ImportAlmamaterVisit
